import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getRequiredMinimumDistribution } from 'services/Rest';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import {
  getIsRMDEligible,
  getIsRMDPreEligible,
  getRMDData
} from 'state/distribution/RequiredMinimumDistributionSelectors';
import { isRMDDirectEnabled, rmdGaugeEnabled } from 'services/FeatureFlags';
import { getApiKey } from 'state/config/ConfigSelectors';
import { getAsOfDate } from 'state/account/AccountSelectors';
import { getCustomerBusinessPartyId } from 'state/customer/CustomerSelectors';

const RequiredMinimumDistributionDataProvider = (WrappedComponent) => {
  class RMDData extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isVisible: false,
        isLoading: true,
        hasError: false,
        data: {}
      };

      this.fetchDataIfNotAvailable.bind(this);
    }

    componentDidMount() {
      this.fetchDataIfNotAvailable();
    }

    componentDidUpdate(prevProps) {
      const { requestStatus, requiredMinimumDistribution } = this.props;
      const callStatusKey = isRMDDirectEnabled()
        ? 'requiredMinimumDistributionSummary'
        : 'requiredMinimumDistribution';

      const previouslyRequestResolved =
        prevProps.requestStatus[callStatusKey] === REQUEST_STATES.received;
      const nowRequestResolved =
        requestStatus[callStatusKey] == REQUEST_STATES.received;
      const requestHasResolved =
        !previouslyRequestResolved && nowRequestResolved;

      if (requestHasResolved) {
        if (rmdGaugeEnabled()) {
          this.setState({
            isLoading: false,
            isVisible:
              requiredMinimumDistribution.customerEligible ||
              requiredMinimumDistribution.customerPreEligible
          });
        } else {
          this.setState({
            isLoading: false,
            isVisible: requiredMinimumDistribution.customerEligible
          });
        }
      }

      if (
        requestHasResolved &&
        requestStatus[callStatusKey] === REQUEST_STATES.error
      ) {
        this.setState({
          isLoading: false,
          isError: true
        });
      }
    }

    fetchDataIfNotAvailable() {
      const { requestStatus } = this.props;
      const callStatusKey = isRMDDirectEnabled()
        ? 'requiredMinimumDistributionSummary'
        : 'requiredMinimumDistribution';

      if (requestStatus[callStatusKey] !== REQUEST_STATES.requested) {
        this.setState({ isLoading: true });
        getRequiredMinimumDistribution();
      }
    }

    render() {
      const { bpId, requiredMinimumDistribution, apiKey, asOfDate } =
        this.props;
      const passThrough = {
        ...this.state,
        data: requiredMinimumDistribution,
        apiKey,
        asOfDate,
        bpId
      };
      return <WrappedComponent {...passThrough} />;
    }
  }
  const mapStateToProps = (state) => ({
    requestStatus: getRequestStatus(state),
    requiredMinimumDistribution: getRMDData(state),
    isRMDPreEligible: getIsRMDPreEligible(state),
    isRMDEligible: getIsRMDEligible(state),
    bpId: getCustomerBusinessPartyId(state),
    apiKey: getApiKey(state),
    asOfDate: getAsOfDate(state)
  });
  return connect(mapStateToProps)(RMDData);
};

export default RequiredMinimumDistributionDataProvider;
